export const QueryGroupApi = Symbol.for('QueryGroupApi');
